const FullScreenLoader = () => {
  return (
    <div className="top-0 left-0 bg-gray-500/30 z-50 w-screen h-screen fixed grid place-items-center">
      <div className="px-10 py-5 rounded-lg bg-white w-fit">Loading...</div>
    </div>
  );
};

export default FullScreenLoader;
